import { ClientCreditAccountsDocument } from "@/__generated__/graphql";
import { useQuery } from "@apollo/client";

export const useClientCreditAccounts = (id: string) => {
  const result = useQuery(ClientCreditAccountsDocument, {
    fetchPolicy: "network-only",
    variables: {
      id,
    },
  });

  const creditAccounts = result.data?.client.creditAccounts || [];

  return {
    ...result,
    creditAccounts,
  };
};
